export const defaultFormData = {
  username: {
    value: '',
    isValid: false,
    isTouched: false,
    message: 'A valid username is required.'
  },
  email: {
    value: '',
    isValid: false,
    isTouched: false,
    message: 'A valid email address is required.'
  }
};

export const defaultAlertConfig = {
  isOpen: false,
  isConfirm: true,
  message: '',
};
